import { LocalizationProvider, StaticDatePicker } from '@mui/x-date-pickers-pro';
import dayjs, { Dayjs } from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { frFR } from '@mui/x-date-pickers/locales';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { getAppDate, updateAppDate } from 'services/API/Administration';
import './AppDate.scss';
import 'dayjs/locale/fr';
import { Button } from '@mui/material';

const AppDate = () => {
  dayjs.locale('fr');
  const [currentAppDate, setCurrentAppDate] = useState<Dayjs | null>(null);
  const [selectedDate, setSelectedDate] = useState<Dayjs | null>(currentAppDate);
  const [hasDateChanged, setHasDateChanged] = useState<boolean>(false);

  useEffect(() => {
    if (currentAppDate === null) {
      fetchAppDate();
    }
  }, []);

  const fetchAppDate = async () => {
    try {
      const responseDate = await getAppDate();
      setCurrentAppDate(dayjs(responseDate.data.data.currentDate));
      setSelectedDate(dayjs(responseDate.data.data.currentDate));
    } catch (error) {
      if (error instanceof Error) {
        toast.error(error.message);
      }
    }
  };

  const handleDateAccept = async (newDate: any) => {
    try {
      await updateAppDate({ newDate: newDate.format('YYYY-MM-DD') });
      setCurrentAppDate(newDate);
      setHasDateChanged(false);
      toast.success("Date de l'application mise à jour avec succès");
    } catch (error) {
      if (error instanceof Error) {
        toast.error(error.message);
      }
    }
  };

  const handleOnChange = (newDate: any) => {
    if (!hasDateChanged) {
      setHasDateChanged(true);
    }
    if (dayjs(newDate).isSame(currentAppDate)) {
      setHasDateChanged(false);
    }
    setSelectedDate(newDate);
  };

  const handleCancel = () => {
    setHasDateChanged(false);
    setSelectedDate(currentAppDate);
  };

  const resetAppDate = async () => {
    if (currentAppDate?.format('YYYY-MM-DD') === dayjs().format('YYYY-MM-DD')) {
      toast.info("La date de l'application est déjà la date par défaut");
      return;
    }
    try {
      await updateAppDate({ newDate: null });
      setCurrentAppDate(dayjs());
      setSelectedDate(dayjs());
      setHasDateChanged(false);
      toast.success("Date de l'application remise à aujourd'hui");
    } catch (error) {
      if (error instanceof Error) {
        toast.error(error.message);
      }
    }
  };

  return (
    <div className="app_date_container">
      <div className="current_date_container">
        <h4>Date actuelle de l'application</h4>
        <h5>{dayjs(currentAppDate).format('DD MMMM YYYY')}</h5>
        <Button variant="outlined" onClick={resetAppDate}>
          Remettre la date par défaut
        </Button>
      </div>
      <div className="date_picker_container">
        <LocalizationProvider
          dateAdapter={AdapterDayjs}
          adapterLocale="fr"
          localeText={frFR.components.MuiLocalizationProvider.defaultProps.localeText}
        >
          <StaticDatePicker
            value={selectedDate}
            onAccept={handleDateAccept} // Appelé quand l'utilisateur clique sur "OK"
            onChange={handleOnChange}
            slotProps={{
              actionBar: {
                onCancel: handleCancel,
                sx: {
                  '& .MuiButton-root': {
                    opacity: hasDateChanged ? 1 : 0.5,
                    pointerEvents: hasDateChanged ? 'auto' : 'none',
                  },
                },
              },
            }}
          />
        </LocalizationProvider>
      </div>
    </div>
  );
};

export default AppDate;
